import { Card, Group, Stack, Text } from "@mantine/core";
import { CSSProperties, type JSX } from "react";

import { DEFAULT_BORDER_RADIUS } from "../../utils/Constants";

const Tile = ({
  title,
  subtitle,
  action,
  content,
  minWidth = 220,
  style,
  contentStyle,
  onClick,
}: {
  title?: string | JSX.Element;
  subtitle?: string;
  action?: JSX.Element;
  content: JSX.Element;
  minWidth?: number;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
  onClick?: () => void;
}) => (
  <Card
    shadow="none"
    padding={0}
    onClick={onClick}
    style={{
      minWidth,
      borderRadius: DEFAULT_BORDER_RADIUS,
      ...style,
    }}
  >
    {title && (
      <Group justify="space-between" align="flex-start" wrap="nowrap" p={16}>
        <Stack gap={0}>
          <Text size="md" fw={600}>
            {title}
          </Text>
          {subtitle && <Text size="sm">{subtitle}</Text>}
        </Stack>
        {action}
      </Group>
    )}
    <Stack gap={0} px={16} pt={title ? 0 : 16} pb={16} style={contentStyle}>
      {content}
    </Stack>
  </Card>
);

export default Tile;
